export const AI_CHAT_ACTION_TYPE = {
  GET_SESSION: 'aiChat/GET_SESSION',
  GET_SESSION_SUCCESS: 'aiChat/GET_SESSION_SUCCESS',
  GET_SESSION_FAILURE: 'aiChat/GET_SESSION_FAILURE',
  GET_MESSAGES: 'aiChat/GET_MESSAGES',
  GET_MESSAGES_SUCCESS: 'aiChat/GET_MESSAGES_SUCCESS',
  GET_MESSAGES_FAILURE: 'aiChat/GET_MESSAGES_FAILURE',
  SEND_MESSAGE: 'aiChat/SEND_MESSAGE',
  SEND_MESSAGE_SUCCESS: 'aiChat/SEND_MESSAGE_SUCCESS',
  SEND_MESSAGE_FAILURE: 'aiChat/SEND_MESSAGE_FAILURE',
  ADD_MESSAGE: 'aiChat/ADD_MESSAGE',
  UPDATE_MESSAGE: 'aiChat/UPDATE_MESSAGE',
  SET_IS_LOADING: 'aiChat/SET_IS_LOADING',
  SET_IS_SENDING: 'aiChat/SET_IS_SENDING',
  SET_ERROR: 'aiChat/SET_ERROR',
  CLEAR_ERROR: 'aiChat/CLEAR_ERROR',
  RESET_STATE: 'aiChat/RESET_STATE',
  SET_IS_PANEL_OPEN: 'aiChat/SET_IS_PANEL_OPEN',
  SET_EXECUTION_PLAN: 'aiChat/SET_EXECUTION_PLAN',
  UPDATE_EXECUTION_PLAN_STEP: 'aiChat/UPDATE_EXECUTION_PLAN_STEP',
  CLEAR_EXECUTION_PLAN: 'aiChat/CLEAR_EXECUTION_PLAN',
  SET_GUIDELINE_FULL_VIEW: 'aiChat/SET_GUIDELINE_FULL_VIEW',
  FETCH_GUIDELINE_CONTENT_FAILURE: 'aiChat/FETCH_GUIDELINE_CONTENT_FAILURE',
  CACHE_GUIDELINE_CONTENT: 'aiChat/CACHE_GUIDELINE_CONTENT',
  CLEAR_GUIDELINE_CACHE: 'aiChat/CLEAR_GUIDELINE_CACHE',
  SET_PENDING_TOOL_EXECUTION: 'aiChat/SET_PENDING_TOOL_EXECUTION',
  CLEAR_PENDING_TOOL_EXECUTION: 'aiChat/CLEAR_PENDING_TOOL_EXECUTION',
  ADD_TOOL_EXECUTION_RESULT: 'aiChat/ADD_TOOL_EXECUTION_RESULT',
  CLEAR_TOOL_EXECUTION_HISTORY: 'aiChat/CLEAR_TOOL_EXECUTION_HISTORY',
  ENSURE_SESSION: 'aiChat/ENSURE_SESSION',
  ENSURE_SESSION_SUCCESS: 'aiChat/ENSURE_SESSION_SUCCESS',
  ENSURE_SESSION_FAILURE: 'aiChat/ENSURE_SESSION_FAILURE',
  PLAN_PLANNING_STARTED: 'aiChat/PLAN_PLANNING_STARTED',
  PLAN_CREATED: 'aiChat/PLAN_CREATED',
  PLAN_UPDATED: 'aiChat/PLAN_UPDATED',
  STEP_STARTED: 'aiChat/STEP_STARTED',
  STEP_COMPLETED: 'aiChat/STEP_COMPLETED',
  STEP_FAILED: 'aiChat/STEP_FAILED',
  TOOL_STARTED: 'aiChat/TOOL_STARTED',
  TOOL_COMPLETED: 'aiChat/TOOL_COMPLETED',
  TOOL_FAILED: 'aiChat/TOOL_FAILED',
  TOOL_CONFIRMATION_REQUESTED: 'aiChat/TOOL_CONFIRMATION_REQUESTED',
  RESPONSE_TOKEN: 'aiChat/RESPONSE_TOKEN',
  RESPONSE_COMPLETE: 'aiChat/RESPONSE_COMPLETE',
  EXECUTION_CANCELLED: 'aiChat/EXECUTION_CANCELLED',
  MESSAGE_FAILED: 'aiChat/MESSAGE_FAILED',
  CITATIONS_EXTRACTED: 'aiChat/CITATIONS_EXTRACTED',
  CITATIONS_BLOB_LOADED: 'aiChat/CITATIONS_BLOB_LOADED',
  MESSAGE_RECEIVED: 'aiChat/MESSAGE_RECEIVED',
  LOAD_UNREAD_COUNT: 'aiChat/LOAD_UNREAD_COUNT',
  LOAD_UNREAD_COUNT_SUCCESS: 'aiChat/LOAD_UNREAD_COUNT_SUCCESS',
  LOAD_UNREAD_COUNT_FAILURE: 'aiChat/LOAD_UNREAD_COUNT_FAILURE',
  MARK_CHAT_READ: 'aiChat/MARK_CHAT_READ',
  MARK_CHAT_READ_SUCCESS: 'aiChat/MARK_CHAT_READ_SUCCESS',
  MARK_CHAT_READ_FAILURE: 'aiChat/MARK_CHAT_READ_FAILURE',
  LOAD_ELIGIBLE_CONFIGURATIONS: 'aiChat/LOAD_ELIGIBLE_CONFIGURATIONS',
  LOAD_ELIGIBLE_CONFIGURATIONS_SUCCESS: 'aiChat/LOAD_ELIGIBLE_CONFIGURATIONS_SUCCESS',
  LOAD_ELIGIBLE_CONFIGURATIONS_FAILURE: 'aiChat/LOAD_ELIGIBLE_CONFIGURATIONS_FAILURE',
  SWITCH_CONFIGURATION: 'aiChat/SWITCH_CONFIGURATION',
  SWITCH_CONFIGURATION_SUCCESS: 'aiChat/SWITCH_CONFIGURATION_SUCCESS',
  SWITCH_CONFIGURATION_FAILURE: 'aiChat/SWITCH_CONFIGURATION_FAILURE',
  TOOL_EXECUTED: 'aiChat/TOOL_EXECUTED',
  TOOL_CANCELLED: 'aiChat/TOOL_CANCELLED',
  TOOL_CONFIRMATION_TIMEOUT: 'aiChat/TOOL_CONFIRMATION_TIMEOUT',
  APPROVE_TOOL_CALL: 'aiChat/APPROVE_TOOL_CALL',
  APPROVE_TOOL_CALL_FAILURE: 'aiChat/APPROVE_TOOL_CALL_FAILURE',
  REJECT_TOOL_CALL: 'aiChat/REJECT_TOOL_CALL',
  REJECT_TOOL_CALL_FAILURE: 'aiChat/REJECT_TOOL_CALL_FAILURE',
  LOAD_PENDING_TOOL_CONFIRMATIONS: 'aiChat/LOAD_PENDING_TOOL_CONFIRMATIONS',
  LOAD_PENDING_TOOL_CONFIRMATIONS_SUCCESS: 'aiChat/LOAD_PENDING_TOOL_CONFIRMATIONS_SUCCESS',
  LOAD_PENDING_TOOL_CONFIRMATIONS_FAILURE: 'aiChat/LOAD_PENDING_TOOL_CONFIRMATIONS_FAILURE',
  SET_IS_CONNECTED: 'aiChat/SET_IS_CONNECTED',
  RETRY_MESSAGE: 'aiChat/RETRY_MESSAGE',
  RETRY_MESSAGE_SUCCESS: 'aiChat/RETRY_MESSAGE_SUCCESS',
  RETRY_MESSAGE_FAILURE: 'aiChat/RETRY_MESSAGE_FAILURE',
  MESSAGE_CONTENT_BLOCK_ADDED: 'aiChat/MESSAGE_CONTENT_BLOCK_ADDED',
  MESSAGE_CONTENT_BLOCK_UPDATED: 'aiChat/MESSAGE_CONTENT_BLOCK_UPDATED',
  MESSAGE_CONTENT_BLOCKS_LOADED: 'aiChat/MESSAGE_CONTENT_BLOCKS_LOADED',
  PLAN_REVISED: 'aiChat/PLAN_REVISED',
  PLAN_STEP_STARTED: 'aiChat/PLAN_STEP_STARTED',
  PLAN_STEP_TOOL_DISPATCHED: 'aiChat/PLAN_STEP_TOOL_DISPATCHED',
  PLAN_STEP_TOOL_RETURNED: 'aiChat/PLAN_STEP_TOOL_RETURNED',
  PLAN_STEP_COMPLETED: 'aiChat/PLAN_STEP_COMPLETED',
  PLAN_STEP_FAILED: 'aiChat/PLAN_STEP_FAILED',
  PLAN_STEP_SKIPPED: 'aiChat/PLAN_STEP_SKIPPED',
  PLAN_STEP_AWAITING_CONFIRMATION: 'aiChat/PLAN_STEP_AWAITING_CONFIRMATION',
  PLAN_STEP_CANCELLED: 'aiChat/PLAN_STEP_CANCELLED',
  PLAN_COMPLETED: 'aiChat/PLAN_COMPLETED',
  PLAN_CANCELLED: 'aiChat/PLAN_CANCELLED',
  CLEAR_PLAN_REVISION_FLAGS: 'aiChat/CLEAR_PLAN_REVISION_FLAGS',
  SET_ACTION_PLAN_EXPANSION: 'aiChat/SET_ACTION_PLAN_EXPANSION',
  SET_ASSISTANT_SLOW: 'aiChat/SET_ASSISTANT_SLOW',
  SET_MESSAGE_FEEDBACK: 'aiChat/SET_MESSAGE_FEEDBACK',
  SET_MESSAGE_FEEDBACK_FAILURE: 'aiChat/SET_MESSAGE_FEEDBACK_FAILURE',
  STOP_SESSION: 'aiChat/STOP_SESSION',
  STOP_SESSION_SUCCESS: 'aiChat/STOP_SESSION_SUCCESS',
  STOP_SESSION_FAILURE: 'aiChat/STOP_SESSION_FAILURE',
  SESSION_STOPPED: 'aiChat/SESSION_STOPPED',
  USER_QUESTION_REQUESTED: 'aiChat/USER_QUESTION_REQUESTED',
  RESPOND_TO_USER_QUESTION: 'aiChat/RESPOND_TO_USER_QUESTION',
  RESPOND_TO_USER_QUESTION_SUCCESS: 'aiChat/RESPOND_TO_USER_QUESTION_SUCCESS',
  RESPOND_TO_USER_QUESTION_FAILURE: 'aiChat/RESPOND_TO_USER_QUESTION_FAILURE',
  DISMISS_USER_QUESTION: 'aiChat/DISMISS_USER_QUESTION',
  DISMISS_USER_QUESTION_SUCCESS: 'aiChat/DISMISS_USER_QUESTION_SUCCESS',
  DISMISS_USER_QUESTION_FAILURE: 'aiChat/DISMISS_USER_QUESTION_FAILURE',
  LOAD_PENDING_QUESTIONS: 'aiChat/LOAD_PENDING_QUESTIONS',
  LOAD_PENDING_QUESTIONS_SUCCESS: 'aiChat/LOAD_PENDING_QUESTIONS_SUCCESS',
  LOAD_PENDING_QUESTIONS_FAILURE: 'aiChat/LOAD_PENDING_QUESTIONS_FAILURE',
};

export const AiPlanUserOutcome = {
  ACCEPTED: 'Accepted',
  DISCARDED: 'Discarded',
  NO_FEEDBACK: 'NoFeedback',
};

export const AI_CHAT_ASSISTANT_SLOW_WARNING_MS = 45000;

export const AI_CHAT_ASSISTANT_SLOW_WARNING_MESSAGE =
  'This is taking a bit longer than usual — the assistant is still working…';

export const AI_CHAT_FEEDBACK_ERROR_MESSAGE = 'Failed to record feedback. Please try again.';

export const CITATION_INLINE_MARKER_REGEX = /\[\^cite:([^\]]+)\]/g;

export const GUIDELINE_UNAVAILABLE_MESSAGE = 'Guideline not yet available';

export const AiChatMessageRole = {
  USER: 'User',
  ASSISTANT: 'Assistant',
  TOOL: 'Tool',
  SYSTEM: 'System',
};

export const ToolActivityStatus = {
  RUNNING: 'Running',
  COMPLETED: 'Completed',
  FAILED: 'Failed',
};

export const AiChatMessageStatus = {
  PENDING: 'Pending',
  SENDING: 'Sending',
  SENT: 'Sent',
  STREAMING: 'Streaming',
  COMPLETED: 'Completed',
  FAILED: 'Failed',
};

export const IN_FLIGHT_MESSAGE_STATUSES = new Set([
  AiChatMessageStatus.PENDING,
  AiChatMessageStatus.SENDING,
  AiChatMessageStatus.STREAMING,
]);

export const AiChatSignalREventType = {
  PLAN_PLANNING_STARTED: 'plan_planning_started',
  PLAN_CREATED: 'plan_created',
  PLAN_UPDATED: 'plan_updated',
  STEP_STARTED: 'step_started',
  STEP_COMPLETED: 'step_completed',
  STEP_FAILED: 'step_failed',
  TOOL_STARTED: 'tool_started',
  TOOL_COMPLETED: 'tool_completed',
  TOOL_FAILED: 'tool_failed',
  TOOL_CONFIRMATION_REQUESTED: 'tool_confirmation_requested',
  TOOL_EXECUTED: 'tool_executed',
  TOOL_CANCELLED: 'tool_cancelled',
  TOOL_CONFIRMATION_TIMEOUT: 'tool_confirmation_timeout',
  RESPONSE_TOKEN: 'response_token',
  RESPONSE_COMPLETE: 'response_complete',
  EXECUTION_CANCELLED: 'execution_cancelled',
  MESSAGE_FAILED: 'message_failed',
  CITATIONS_EXTRACTED: 'citations_extracted',
  MESSAGE_RECEIVED: 'message_received',
  MESSAGE_CONTENT_BLOCK_ADDED: 'message_content_block_added',
  MESSAGE_CONTENT_BLOCK_UPDATED: 'message_content_block_updated',
  PLAN_REVISED: 'plan_revised',
  PLAN_STEP_STARTED: 'plan_step_started',
  PLAN_STEP_TOOL_DISPATCHED: 'plan_step_tool_dispatched',
  PLAN_STEP_TOOL_RETURNED: 'plan_step_tool_returned',
  PLAN_STEP_COMPLETED: 'plan_step_completed',
  PLAN_STEP_FAILED: 'plan_step_failed',
  PLAN_STEP_SKIPPED: 'plan_step_skipped',
  PLAN_STEP_AWAITING_CONFIRMATION: 'plan_step_awaiting_confirmation',
  PLAN_STEP_CANCELLED: 'plan_step_cancelled',
  PLAN_COMPLETED: 'plan_completed',
  PLAN_CANCELLED: 'plan_cancelled',
  TOOL_EXECUTION_REQUESTED: 'tool_execution_requested',
  ROUTER_CLASSIFIED: 'router_classified',
  SESSION_STOPPED: 'session_stopped',
  USER_QUESTION_REQUESTED: 'user_question_requested',
};

export const ActionStepStatus = {
  PENDING: 'pending',
  STARTING: 'starting',
  RUNNING: 'running',
  STREAMING: 'streaming',
  SUCCESS: 'success',
  ERROR: 'error',
  CANCELLED: 'cancelled',
  SKIPPED: 'skipped',
  // DEV-2913: row paused on a FE confirmation card (today emitted for
  // `open_loan_section`). Rendered with a distinct "Awaiting confirmation"
  // badge — not the generic Running spinner — so the user sees that the
  // step is waiting on them, not crashed.
  AWAITING_CONFIRMATION: 'awaitingConfirmation',
};

export const ACTION_STEP_TERMINAL_STATUSES = new Set([
  ActionStepStatus.SUCCESS,
  ActionStepStatus.ERROR,
  ActionStepStatus.CANCELLED,
  ActionStepStatus.SKIPPED,
]);

export const ACTION_STEP_HEARTBEAT_TICK_MS = 250;

export const ToolConfirmationStatus = {
  PENDING: 'pending',
  APPROVING: 'approving',
  REJECTING: 'rejecting',
  EXECUTED: 'executed',
  FAILED: 'failed',
  CANCELLED: 'cancelled',
  TIMED_OUT: 'timedOut',
};

export const PENDING_TOOL_CONFIRMATION_STATUSES = new Set([
  ToolConfirmationStatus.PENDING,
  ToolConfirmationStatus.APPROVING,
  ToolConfirmationStatus.REJECTING,
]);

export const UserQuestionStatus = {
  PENDING: 'pending',
  SUBMITTING: 'submitting',
  DISMISSING: 'dismissing',
  ANSWERED: 'answered',
  DISMISSED: 'dismissed',
};

export const PENDING_USER_QUESTION_STATUSES = new Set([
  UserQuestionStatus.PENDING,
  UserQuestionStatus.SUBMITTING,
  UserQuestionStatus.DISMISSING,
]);

export const AiChatActivityPhase = {
  IDLE: 'idle',
  AWAITING_APPROVAL: 'awaitingApproval',
  WRITING: 'writing',
  RUNNING_TOOL: 'runningTool',
  PLANNING: 'planning',
  THINKING: 'thinking',
  STILL_THINKING: 'stillThinking',
};

export const ToolConfirmationPolicy = {
  AUTO: 'Auto',
  NOTIFY: 'Notify',
  CONFIRM: 'Confirm',
};

export const AiChatSignalRMessageType = {
  CONNECT_TO_AI_CHAT_HUB: 'JoinSession',
  DISCONNECT_FROM_AI_CHAT_HUB: 'LeaveSession',
  RESPOND_TO_TOOL_CONFIRMATION: 'RespondToToolConfirmation',
  RESPOND_TO_USER_QUESTION: 'RespondToUserQuestion',
  SEND_TOOL_RESULT: 'SendToolResult',
};

// DEV-3192: per-tool SLA-group resolution mode carried on the active chat
// configuration's toolSlaGroups map (toolName -> { mode, slaGroupId? }). Fixed
// uses the configured group; PromptUser requires the human to pick a group at
// the tool-confirmation card before the condition tool can run.
export const ToolSlaGroupMode = {
  FIXED: 'Fixed',
  PROMPT_USER: 'PromptUser',
};

export const ExecutionStepStatus = {
  PENDING: 'pending',
  EXECUTING: 'executing',
  COMPLETED: 'completed',
  FAILED: 'failed',
  CANCELLED: 'cancelled',
  SKIPPED: 'skipped',
};

export const AiChatPlanStatus = {
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  FAILED: 'failed',
  CANCELLED: 'cancelled',
};

export const AiChatPlanStepStatus = {
  PENDING: 'pending',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  FAILED: 'failed',
  SKIPPED: 'skipped',
  // DEV-2913: chat-only — the bridged advisory step is paused on a FE
  // confirmation card (today emitted for `open_loan_section`). Distinct
  // from IN_PROGRESS so the card renders an "Awaiting confirmation" badge
  // instead of a generic spinner. Transitions to COMPLETED on user approve
  // or CANCELLED on user reject via the BE resume path.
  AWAITING_CONFIRMATION: 'awaiting_confirmation',
  // DEV-2913: chat-only — user explicitly rejected the FE confirmation
  // card. Distinct from FAILED (no error) and SKIPPED (model never invoked).
  CANCELLED: 'cancelled',
};

export const ActionStepType = {
  DATA_READING: 'dataReading',
  EXECUTING_COMMAND: 'executingCommand',
  MODIFYING_RECORD: 'modifyingRecord',
  ANALYZING: 'analyzing',
  GUIDELINE_LOOKUP: 'guidelineLookup',
  MODEL_TURN: 'modelTurn',
  SPECIALIST: 'specialist',
  SKILL_USE: 'skillUse',
  AGENT_DELEGATION: 'agentDelegation',
};

export const ActionStepContentType = {
  TEXT: 'Text',
  CONFIRM_ACTIONS: 'ConfirmActions',
  LIST: 'List',
  ERROR: 'Error',
  STEP_SUMMARY: 'StepSummary',
  SCANNED_SECTIONS: 'ScannedSections',
  TOOL_CALLS: 'ToolCalls',
};

export const AiPlanStepKind = {
  TOOL_CALL: 'ToolCall',
  MODEL_TURN: 'ModelTurn',
  SPECIALIST: 'Specialist',
};

export const PLAN_REVISION_FLAG_TIMEOUT_MS = 1200;

export const ACTION_PLAN_STEP_EXPANSION_KEY = 'step';

export const ToolExecutionStatus = {
  PENDING: 'pending',
  CONFIRMING: 'confirming',
  EXECUTING: 'executing',
  COMPLETED: 'completed',
  FAILED: 'failed',
  CANCELLED: 'cancelled',
};

export const ToolConfirmationLevel = {
  NONE: 'none',
  NOTIFY: 'notify',
  CONFIRM: 'confirm',
};

export const TOOL_CONFIRMATION_CONFIG = {
  navigate_to_tab: ToolConfirmationLevel.NONE,
  navigate_to_borrower: ToolConfirmationLevel.NONE,
  navigate_to_section: ToolConfirmationLevel.NONE,
  open_loan_section: ToolConfirmationLevel.CONFIRM,
  edit_field: ToolConfirmationLevel.CONFIRM,
  edit_fields: ToolConfirmationLevel.CONFIRM,
  create_task: ToolConfirmationLevel.CONFIRM,
  add_condition: ToolConfirmationLevel.CONFIRM,
  request_document: ToolConfirmationLevel.CONFIRM,
  update_loan_status: ToolConfirmationLevel.CONFIRM,
};

export const OpenLoanSectionArea = {
  INCOMES: 'incomes',
  ASSETS: 'assets',
  LIABILITIES: 'liabilities',
  BORROWER: 'borrower',
  PROPERTIES: 'properties',
  FINANCIAL_VIEW: 'financial-view',
  TASKS: 'tasks',
  DOCUMENTS: 'documents',
  CLOSING: 'closing',
  FIELD: 'field',
};

export const OPEN_LOAN_SECTION_AREA_LABEL = {
  [OpenLoanSectionArea.INCOMES]: 'Income',
  [OpenLoanSectionArea.ASSETS]: 'Assets',
  [OpenLoanSectionArea.LIABILITIES]: 'Liabilities',
  [OpenLoanSectionArea.BORROWER]: 'Borrower',
  [OpenLoanSectionArea.PROPERTIES]: 'Properties',
  [OpenLoanSectionArea.FINANCIAL_VIEW]: 'Financial Information',
  [OpenLoanSectionArea.TASKS]: 'Tasks',
  [OpenLoanSectionArea.DOCUMENTS]: 'Documents',
  [OpenLoanSectionArea.CLOSING]: 'Closing',
  [OpenLoanSectionArea.FIELD]: 'Field',
};

export const getToolConfirmationLevel = toolName => {
  if (TOOL_CONFIRMATION_CONFIG[toolName]) {
    return TOOL_CONFIRMATION_CONFIG[toolName];
  }

  if (toolName.startsWith('navigate_to_')) {
    return ToolConfirmationLevel.NONE;
  }

  if (toolName.startsWith('edit_') || toolName.startsWith('update_')) {
    return ToolConfirmationLevel.CONFIRM;
  }

  if (toolName.startsWith('create_') || toolName.startsWith('add_')) {
    return ToolConfirmationLevel.CONFIRM;
  }

  return ToolConfirmationLevel.NONE;
};

export const TOOL_FRIENDLY_MESSAGES = {
  get_borrowers: 'Looking at loan borrowers...',
  get_borrower: 'Reading borrower details...',
  get_incomes: 'Reviewing income information...',
  get_assets: 'Checking asset information...',
  get_liabilities: 'Reviewing liabilities...',
  get_conditions: 'Checking loan conditions...',
  get_tasks: 'Looking at loan tasks...',
  get_documents: 'Reviewing loan documents...',
  get_loan_application: 'Reading loan application data...',
  get_property: 'Checking property information...',
  get_guideline_section: 'Consulting lending guidelines...',
  navigate_to_tab: 'Navigating to tab...',
  navigate_to_borrower: 'Navigating to borrower...',
  open_loan_section: 'Open loan section',
  edit_field: 'Preparing changes...',
  create_task: 'Creating task...',
  add_condition: 'Adding condition...',
  calculate_dti: 'Calculating debt-to-income ratio...',
  check_eligibility: 'Checking loan eligibility...',
  get_pricing: 'Retrieving pricing information...',
  get_fees: 'Looking at loan fees...',
  get_credit_report: 'Reviewing credit report...',
};

export const GuidelineSource = {
  FANNIE_MAE: 'Fannie Mae Selling Guide',
  FREDDIE_MAC: 'Freddie Mac Seller/Servicer Guide',
  FHA: 'FHA Handbook',
  VA: 'VA Lender Handbook',
  USDA: 'USDA Handbook',
};

export const getGuidelineSourceShortName = source => {
  const shortNames = {
    [GuidelineSource.FANNIE_MAE]: 'FNMA',
    [GuidelineSource.FREDDIE_MAC]: 'FHLMC',
    [GuidelineSource.FHA]: 'FHA',
    [GuidelineSource.VA]: 'VA',
    [GuidelineSource.USDA]: 'USDA',
  };

  return shortNames[source] || source;
};

export const formatGuidelineCitationText = citation => {
  const shortName = getGuidelineSourceShortName(citation.source);

  return `${shortName} ${citation.section}`;
};

export const getToolFriendlyMessage = toolName => {
  if (TOOL_FRIENDLY_MESSAGES[toolName]) {
    return TOOL_FRIENDLY_MESSAGES[toolName];
  }

  if (toolName.startsWith('navigate_to_')) {
    const target = toolName.replace('navigate_to_', '').replace(/_/g, ' ');

    return `Navigating to ${target}...`;
  }

  if (toolName.startsWith('get_')) {
    const target = toolName.replace('get_', '').replace(/_/g, ' ');

    return `Reading ${target}...`;
  }

  return `Executing ${toolName.replace(/_/g, ' ')}...`;
};
